import { Translatable } from '../../../../feature/localization/model/Text'
import { BaseGoBackButton } from '../atom/BaseGoBackButton'
import { useLocalizationStore } from '../../../../feature/localization/store/localization.store'
import { observer } from 'mobx-react-lite'
import { Theme } from '@mui/material'

interface Props {
  textValue?: Translatable
  sx?: any
  to?: string
}

export const GoBackButtonWithArrow = observer((props: Props) => {
  const localization = useLocalizationStore()

  const { textValue = localization.translation.buttons.goBack, to } = props

  return (
    <BaseGoBackButton
      sx={{ ...styles.root, ...props.sx }}
      textValue={textValue}
      to={to}
      underline='hover'
    />
  )
})

const styles = {
  root: {
    color: 'text.secondary',
    fontSize: 12,
    textDecorationColor: (theme: Theme) => theme.palette.text.primary,
    '&:hover': {
      textDecorationColor: (theme: Theme) => theme.palette.text.primary,
    },
  },
}
